import trackEvent from "@analytics/utils/trackEvent";

import { IContactTableControls } from "@store/filters/filter.types";

import { getKeysOfValuesChanged } from "@utilities/diffDictionaries";

const ContactsAnalyticsService = {
  trackContactEmailCopied: () => trackEvent("Contact Email Copied", {}),
  trackContactFilter: (
    newContactFilters: IContactTableControls,
    oldContactFilters: IContactTableControls,
    workflow: string,
  ) => {
    const modifiedFilters = getKeysOfValuesChanged(oldContactFilters.filters, newContactFilters.filters).filter(
      (filter) => filter !== "search",
    );
    if (modifiedFilters.length > 0) {
      trackEvent("Filter Applied", {
        modified_filters: modifiedFilters,
        type: "Contact Filter",
        workflow,
      });
    }
  },
  trackContactsDownloaded: (rowCount: number) =>
    trackEvent("File Downloaded", {
      file_name: "contactList",
      row_count: rowCount,
    }),
} as const;

export default ContactsAnalyticsService;
